import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { routing } from '../../../app.routing';
import { PipesModule } from '../../pipes/pipes.module';
import { ButtonsModule } from '~shared/components/buttons/buttons.module';
import { AccordionTableComponent } from './accordion-table/accordion-table.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { PaginatedTableComponent } from './paginated-table/paginated-table.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { TableRowComponent } from './table-row/table-row.component';
import { TableComponent } from './table/table.component';
import { TablesTranslations } from './tables-translations.service';
import { TooltipModule } from '~shared/components/tooltip/tooltip.module';

/**
 * Module for the Manage section
 */
@NgModule({
  declarations: [
    PaginatorComponent,
    PaginatedTableComponent,
    AccordionTableComponent,
    TableComponent,
    TableRowComponent,
    EmptyStateComponent
  ],
  exports: [
    PaginatorComponent,
    PaginatedTableComponent,
    AccordionTableComponent,
    TableComponent,
    TableRowComponent,
    EmptyStateComponent
  ],
  providers: [
    TablesTranslations
  ],
  imports: [
    routing,
    CommonModule,
    TooltipModule,
    ButtonsModule,
    PipesModule,
  ]
})
export class TablesModule { }
